import events from '../../../../events.js'
import eventVersionsMapper from './eventVersionsMappers/index.js'

const {
  AD_FAVORITED,
  AD_INSERTED_ERROR,
  AD_INSERTED,
  AD_INSERTION_BUTTON_CLICKED,
  AD_INSERTION_FIELD_AUTOCOMPLETED,
  AD_INSERTION_IO_CAR_DETAILS_SUCCESS,
  AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED,
  AD_INSERTION_IO_DATE_CONFIRMED,
  AD_INSERTION_IO_DATE_SELECTED,
  AD_INSERTION_IO_DEALER_SELECTED,
  AD_INSERTION_IO_DEALERS_AND_DATES_VIEWED,
  AD_INSERTION_IO_HOUR_SELECTED,
  AD_INSERTION_IO_NO_OFFER_AVAILABLE,
  AD_INSERTION_IO_VIEWED,
  AD_INSERTION_VIEWED,
  AD_MODIFIED,
  AD_SHARED,
  AI_SEARCH_USED,
  ALERT_CREATED,
  APP_DOWNLOAD_BUTTON_CLICKED,
  APPRAISAL_REQUESTED,
  APPRAISAL_SELECT_DEALER_CONFIRMED,
  DEALER_STOCK_CLICKED,
  DETAIL_NAVBAR_CLICKED,
  DETAIL_VIEWED,
  FILTER_ADDED,
  FILTERS_RESTART_CLICKED,
  HOME_IO_BUTTON_CLICKED,
  INSTANT_OFFER_FORM_VIEWED,
  INSTANT_OFFER_NEXT_CONFIRMED,
  LANDING_IO_DATE_CONFIRMED,
  LANDING_IO_NEXT_CONFIRMED,
  LANDING_IO_VIEWED,
  LAST_DETAILS_SEEN,
  LEAD_ENRICHED,
  LEAD_ERROR,
  LEAD_TRIGGERED,
  MAP_CLICKED,
  LIST_NEWS_SAVED_CLICKED,
  LIST_NEWS_SAVED_VIEWED,
  NEWS_DETAIL_VIEWED,
  PHONE_VIEWED,
  RECOMMENDED_ADS_FALLBACK,
  RESERVATION_DRAWER_VIEWED,
  RESERVATION_MORE_INFORMATION_CLICKED,
  RESERVATION_PAYMENT_VIEWED,
  RESERVATION_START_CLICKED,
  RESERVATION_SUCCESS,
  SEND_MESSAGE_BUTTON_CLICKED,
  SIGNED_IN,
  SIGNED_UP,
  SIGNED_IN_ERROR,
  SIGNED_UP_ERROR,
  WEBSITE_CLICKED,
  ACCESS_TO_AD_INSERTION_CLICKED,
  ACCESS_TO_INSTANT_OFFER_CLICKED,
  LIST_VIEWED
} = events

const {dealerStockClickedEventVersionsMapper, defaultEventVersionsMapper, authenticationEventVersionsMapper} =
  eventVersionsMapper

const DEFAULT_EVENT_VERSION = null

export default ({payload, next}) => {
  const {
    obj: {
      context: {protocols = {}},
      event
    }
  } = payload

  let eventVersion

  switch (event) {
    case ACCESS_TO_AD_INSERTION_CLICKED:
    case ACCESS_TO_INSTANT_OFFER_CLICKED:
    case AD_FAVORITED:
    case AD_INSERTION_IO_CAR_DETAILS_SUCCESS:
    case AD_INSERTED_ERROR:
    case AD_INSERTED:
    case AD_INSERTION_BUTTON_CLICKED:
    case AD_INSERTION_FIELD_AUTOCOMPLETED:
    case AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED:
    case AD_INSERTION_IO_DATE_CONFIRMED:
    case AD_INSERTION_IO_DATE_SELECTED:
    case AD_INSERTION_IO_DEALER_SELECTED:
    case AD_INSERTION_IO_DEALERS_AND_DATES_VIEWED:
    case AD_INSERTION_IO_HOUR_SELECTED:
    case AD_INSERTION_IO_NO_OFFER_AVAILABLE:
    case AD_INSERTION_IO_VIEWED:
    case AD_INSERTION_VIEWED:
    case AD_MODIFIED:
    case AD_SHARED:
    case AI_SEARCH_USED:
    case ALERT_CREATED:
    case APP_DOWNLOAD_BUTTON_CLICKED:
    case APPRAISAL_REQUESTED:
    case APPRAISAL_SELECT_DEALER_CONFIRMED:
    case DETAIL_NAVBAR_CLICKED:
    case DETAIL_VIEWED:
    case FILTER_ADDED:
    case FILTERS_RESTART_CLICKED:
    case HOME_IO_BUTTON_CLICKED:
    case INSTANT_OFFER_FORM_VIEWED:
    case INSTANT_OFFER_NEXT_CONFIRMED:
    case LANDING_IO_DATE_CONFIRMED:
    case LANDING_IO_NEXT_CONFIRMED:
    case LANDING_IO_VIEWED:
    case LAST_DETAILS_SEEN:
    case LEAD_ENRICHED:
    case LEAD_ERROR:
    case LEAD_TRIGGERED:
    case LIST_NEWS_SAVED_CLICKED:
    case LIST_NEWS_SAVED_VIEWED:
    case LIST_VIEWED:
    case MAP_CLICKED:
    case NEWS_DETAIL_VIEWED:
    case PHONE_VIEWED:
    case RECOMMENDED_ADS_FALLBACK:
    case RESERVATION_DRAWER_VIEWED:
    case RESERVATION_MORE_INFORMATION_CLICKED:
    case RESERVATION_PAYMENT_VIEWED:
    case RESERVATION_START_CLICKED:
    case RESERVATION_SUCCESS:
    case SEND_MESSAGE_BUTTON_CLICKED:
    case SIGNED_IN_ERROR:
    case SIGNED_UP_ERROR:
    case WEBSITE_CLICKED:
      // When there is no need to choose an appropiate event version
      // based on event properties, use defaultEventVersionsMapper
      eventVersion = defaultEventVersionsMapper({event})
      break
    case SIGNED_IN:
    case SIGNED_UP:
      eventVersion = authenticationEventVersionsMapper({event, payload})
      break
    case DEALER_STOCK_CLICKED:
      eventVersion = dealerStockClickedEventVersionsMapper({payload})
      break
    default:
      eventVersion = DEFAULT_EVENT_VERSION
      break
  }

  if (eventVersion) {
    payload.obj.context.protocols = {
      ...protocols,
      event_version: eventVersion
    }
  }

  next(payload)
}
